import styled from "styled-components";


export const AllCaps = styled.div`
  text-transform: uppercase;      /* wirkt auf alle Nachkommen */
  letter-spacing: .02em;
  .no-caps { text-transform: none !important; } /* Ausnahmen */
`;

